import { bindActionCreators } from 'redux';

import { setFailedValidations } from 'app/App/actions';
import editStatusSelector from 'app/App/selectors/editStatus';
import contractMapSelector from 'app/App/selectors/contractMap';
import variationMapSelector from 'app/App/selectors/variationMap';

import failedValidationsSelector from 'app/App/selectors/failedValidations';
import audienceTagsSelector from 'app/App/selectors/audienceTags';
import componentSelector from 'app/Canvas/selectors/component';
import canEditComponentSelector from 'app/Can/selectors/canEditComponent';
import { openComponentForEditing } from 'app/CanvasComponent/actions';
import { clearComponentUsage } from 'app/ComponentUsage/actions';
import { getComponentUsage } from 'app/ComponentUsage/thunks';
import parametersSelector from 'app/Experiments/selectors/parameters';
import { removeAddedComponentFromPage } from 'app/Explorer/thunks';
import { compareAndFetchSizes } from 'app/ImageSize/thunks';
import { notifyFailure } from 'app/Notifications/actions';
import isPageSelectedSelector from 'app/Page/selectors/isPageSelected';
import pageComponentSelector from 'app/Page/selectors/pageComponent';
import { visitComponent } from 'app/Router/actions';
import { clearSearch } from 'app/Search/actions';
import isComponentFavoriteSelector from 'app/UserInfo/selectors/isComponentFavorite';
import { toggleFavoriteContentThunk } from 'app/UserInfo/thunks';
import connect from 'utils/store/connect';

import { clearComponentApiResponse, modifyComponent } from './actions';
import EditorPane from './components/EditorPane';
import editorPaneSelector from './selectors/editorPane';
import isFetchingComponentSelector from './selectors/isFetchingComponent';
import {
  checkComponentNameAvailabilityThunk,
  copyComponentThunk,
  getDynamicValuesThunk,
  openParentComponentForEditingThunk,
  saveAndVisitComponentThunk,
  unpublishComponentThunk
} from './thunks';

/**
 * Return object mapping canvas state to prop
 * @param {object} state - Redux state object
 * @returns {object} Object for react props
 */
export const mapStateToProps = state => ({
  component: componentSelector(state),
  experimentParameters: parametersSelector(state),
  editStatus: editStatusSelector(state),
  editorPane: editorPaneSelector(state),
  failedValidations: failedValidationsSelector(state),
  isFavorite: isComponentFavoriteSelector(state, componentSelector(state).Id),
  isFetchingComponent: isFetchingComponentSelector(state),
  isPageSelected: isPageSelectedSelector(state),
  contractMap: contractMapSelector(state),
  variationMap: variationMapSelector(state),
  isReadonly: !canEditComponentSelector(state),
  pageComponent: pageComponentSelector(state),
  audienceTags: audienceTagsSelector(state)
});

/**
 * map action creators to react component properties
 * @param {Function} dispatch - redux dispatch function
 * @returns {object} react props
 */
const mapDispatch = function mapDispatchToProps(dispatch) {
  const bindables = {
    clearComponentApiResponse,
    clearComponentUsage,
    clearSearch,
    compareAndFetchSizes,
    modifyComponent,
    notifyFailure,
    openComponentForEditing,
    removeAddedComponentFromPage,
    setFailedValidations,
    visitComponent,

    checkComponentNameAvailability: checkComponentNameAvailabilityThunk,
    copyComponent: copyComponentThunk,
    getComponentUsage,
    getDynamicValues: getDynamicValuesThunk,
    openParentComponentForEditing: openParentComponentForEditingThunk,
    saveComponent: saveAndVisitComponentThunk,
    toggleFavoriteContent: toggleFavoriteContentThunk,
    unpublishComponent: unpublishComponentThunk
  };
  return {
    ...bindActionCreators(bindables, dispatch),
    unboundVisitComponent: visitComponent
  };
};

export default connect(mapStateToProps, mapDispatch)(EditorPane);
